import { render, staticRenderFns } from "./sellerStatus.vue?vue&type=template&id=728a748c"
import script from "./sellerStatus.vue?vue&type=script&lang=js"
export * from "./sellerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports